import React from 'react'
import './info.css'

const Info = ({text}) => {
  return (
    <div className='info'>
        <h3 className='project-title'>{text.title}</h3>
        <p className="project-description">{text.desc}</p>
    </div>
  )
}

export default Info